export default __webpack_public_path__ + "static/media/dummy_pawn_white.07ade20e.svg";